import React from 'react';
import {
  ButtonBar,
  ButtonWrapper,
  Button,
  DropdownIcon,
  Submenu,
  SubmenuGroup,
  SubmenuHeading,
  SubItem,
} from './styled';

const NavigationMenu = ({
  navSections,
  openSubmenu,
  isSectionActive,
  handleSectionClick,
  handleSubItemClick,
}) => (
  <ButtonBar>
    {navSections.map(section => {
      const sectionActive = isSectionActive(section);
      const hasSubmenu = Array.isArray(section.submenus) && section.submenus.length > 0;
      const isExpanded = openSubmenu === section.label;
      return (
        <ButtonWrapper key={section.label}>
          <Button
            type="button"
            active={sectionActive}
            onClick={() => handleSectionClick(section)}
            aria-haspopup={hasSubmenu ? 'true' : undefined}
            aria-expanded={hasSubmenu ? isExpanded : undefined}
          >
            {section.label}
            {hasSubmenu && (
              <DropdownIcon size={14} strokeWidth={2} $expanded={isExpanded} />
            )}
          </Button>
          {hasSubmenu && isExpanded && (
            <Submenu>
              {section.submenus.map((group, index) => (
                <SubmenuGroup key={`${section.label}-group-${index}`}>
                  {group.title && <SubmenuHeading>{group.title}</SubmenuHeading>}
                  {group.items.map(item => (
                    <SubItem
                      key={item.path}
                      type="button"
                      onClick={() => handleSubItemClick(item, section.label)}
                    >
                      {item.label}
                    </SubItem>
                  ))}
                </SubmenuGroup>
              ))}
            </Submenu>
          )}
        </ButtonWrapper>
      );
    })}
  </ButtonBar>
);

export default NavigationMenu;

